// extracted by mini-css-extract-plugin
module.exports = {"ratingNumber":"az_oLc","ratingReviews":"az_pLc","ratingsContainer":"az_qLc"};